<template>
    <div>
        <dx-grid
            url="campDistribution"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="menuItemsDialog" max-width="1380">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Menu Items</v-card-title
                >
                <v-layout row class="">
                    <v-btn
                        small
                        style="height: 28px;"
                        color="success"
                        class="mb-2"
                        @click="addItem"
                        v-if="!newItems.length"
                        >Add Item</v-btn
                    >
                    <v-btn
                        v-if="menuItems.some((i) => i.selected)"
                        class="mb-3 ml-2"
                        small
                        style="height: 28px;"
                        color="warning"
                        @click="deleteItems"
                        >Delete Items</v-btn
                    >
                </v-layout>
                <div v-for="(newItem, index) in newItems">
                    <v-layout row class="pa-0 ml-3 mb-0">
                        <v-text-field
                            class="width-250 mr-1"
                            v-model="newItem.name"
                            label="Name"
                            :rules="[rules.required]"
                            ref="newName"
                        ></v-text-field>
                        <v-select
                            class="width-120 mx-2"
                            v-model="newItem.choiceType"
                            label="Choice Type"
                            :items="['INPUT', 'CHOOSE']"
                            ref="choiceType"
                        ></v-select>
                        <v-checkbox
                            class="width-150 my-0 pt-3 mx-1"
                            hide-details
                            label="Allow Change"
                            v-model="newItem.allowChange"
                            color="success"
                        ></v-checkbox>
                        <v-text-field
                            class="width-100 mx-1"
                            v-model="newItem.standard"
                            label="Standard"
                            ref="standard"
                        ></v-text-field>
                        <v-text-field
                            class="width-150 mx-1"
                            v-model="newItem.distributionType"
                            label="Distribution Type"
                            :rules="[rules.required]"
                            ref="newDistributionType"
                        ></v-text-field>
                        <v-text-field
                            class="width-100 mx-1"
                            v-model="newItem.maxInput"
                            label="Max Input"
                            type="number"
                        ></v-text-field>
                        <v-text-field
                            class="width-200"
                            v-model="newItem.sort"
                            label="Sort Order"
                            type="number"
                        ></v-text-field>
                    </v-layout>
                    <div v-if="newItem.choiceType == 'CHOOSE'">
                        <v-btn
                            small
                            color="success"
                            class="ml-2 mt-0"
                            @click="addChoice(newItem)"
                            >Add Choice</v-btn
                        >
                        <v-layout
                            row
                            class="pa-0 ml-3 mb-0"
                            v-for="(choice, choiceIndex) in newItem.choices"
                        >
                            <v-text-field
                                class="width-300 mr-2"
                                v-model="choice.choice"
                                label="Choice"
                            ></v-text-field>
                            <v-text-field
                                class="width-100"
                                v-model="choice.ivrInput"
                                label="IVR Input"
                                type="number"
                            ></v-text-field>
                            <v-btn
                                @click="addChoice(newItem)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn
                                @click="removeChoice(newItem, choiceIndex)"
                                flat
                                icon
                                color="#f55a4e"
                            >
                                <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                        </v-layout>
                    </div>
                </div>
                <v-card-actions class="pt-0 ml-3" v-if="newItems.length">
                    <v-btn color="default" dark @click="cancelNewItems()"
                        >cancel
                    </v-btn>
                    <v-btn
                        color="success"
                        @click="saveMenuItem(newItems[0], true)"
                        >Save Item
                    </v-btn>
                </v-card-actions>
                <v-divider class="mb-4" v-if="newItems.length"></v-divider>
                <v-layout row class="pa-0 ml-3 mb-0 font-weight-medium">
                    <div class="width-50"></div>

                    <div class="width-250 pt-1">
                        Name
                    </div>
                    <div class="width-120 pt-1">
                        Choice Type
                    </div>
                    <div class="width-150 pt-1">
                        Allow Change
                    </div>
                    <div class="width-100 pt-1">
                        Standard
                    </div>
                    <div class="width-150 pt-1">
                        Distribution Type
                    </div>
                    <div class="width-100 pt-1">
                        Max Input
                    </div>
                    <div class="width-100 pt-1">
                        Sort
                    </div>
                    <div class="pt-1">
                        Choices
                    </div>
                </v-layout>
                <v-divider class="pb-0 pt-3"></v-divider>
                <div style="height: 450px; overflow-y: auto;">
                    <div v-for="(item, index) in menuItems">
                        <v-layout
                            row
                            class="pa-0 ml-3 mb-0"
                            v-if="!item.editing"
                        >
                            <v-checkbox
                                class="width-50 my-0"
                                hide-details
                                v-model="item.selected"
                                color="success"
                            ></v-checkbox>

                            <div class="width-250 pt-1">
                                {{ item.name }}
                            </div>
                            <div class="width-120 pt-1">
                                {{ item.choiceType }}
                            </div>
                            <div class="width-150 pt-1">
                                {{ item.allowChange ? "Yes" : "No" }}
                            </div>
                            <div class="width-100 pt-1">
                                {{ item.standard }}
                            </div>
                            <div class="width-150 pt-1">
                                {{ item.distributionType }}
                            </div>
                            <div class="width-100 pt-1">
                                {{ item.maxInput }}
                            </div>
                            <div class="width-100 pt-1">
                                {{ item.sort }}
                            </div>
                            <div class="pt-1 width-150">
                                {{ item.choicesDisplay }}
                            </div>
                            <v-btn
                                @click="editItem(item)"
                                flat
                                icon
                                class="my-0"
                                color="success"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout
                            row
                            class="pa-0 ml-3 mb-0"
                            v-if="item.editing"
                        >
                            <v-text-field
                                class="width-250 mr-1"
                                v-model="item.name"
                                label="Name"
                                :rules="[rules.required]"
                                ref="name"
                            ></v-text-field>
                            <v-select
                                class="width-120 mx-1"
                                v-model="item.choiceType"
                                label="Choice Type"
                                :items="['INPUT', 'CHOOSE']"
                                ref="choiceType"
                            ></v-select>
                            <v-checkbox
                                class="width-150 my-0 pt-3 mx-1"
                                hide-details
                                label="Allow Change"
                                v-model="item.allowChange"
                                color="success"
                            ></v-checkbox>
                            <v-text-field
                                class="width-100 mx-1"
                                v-model="item.standard"
                                label="Standard"
                                ref="standard"
                            ></v-text-field>
                            <v-text-field
                                class="width-150 mx-1"
                                v-model="item.distributionType"
                                label="Distribution Type"
                                :rules="[rules.required]"
                                ref="distributionType"
                            ></v-text-field>
                            <v-text-field
                                class="width-100 mx-1"
                                v-model="item.maxInput"
                                label="Max Input"
                                type="number"
                            ></v-text-field>
                            <v-text-field
                                class="width-200"
                                v-model="item.sort"
                                label="Sort Order"
                                type="number"
                            ></v-text-field>
                            <v-btn
                                small
                                class="ml-2"
                                color="default"
                                dark
                                style="height: 28px;"
                                @click="rollbackItem(item)"
                                >Cancel</v-btn
                            >
                            <v-btn
                                small
                                color="success"
                                style="height: 28px;"
                                @click="saveMenuItem(item)"
                                >Save</v-btn
                            >
                        </v-layout>
                        <div v-if="item.editing && item.choiceType == 'CHOOSE'">
                            <v-btn
                                small
                                color="success"
                                class="ml-2 mt-0"
                                @click="addChoice(item)"
                                >Add Choice</v-btn
                            >
                            <v-layout
                                row
                                class="pa-0 ml-3 mb-0"
                                v-for="(choice, choiceIndex) in item.choices"
                            >
                                <v-text-field
                                    class="width-300 mr-2"
                                    v-model="choice.choice"
                                    label="Choice"
                                ></v-text-field>
                                <v-text-field
                                    class="width-100"
                                    v-model="choice.ivrInput"
                                    label="IVR Input"
                                    type="number"
                                ></v-text-field>
                                <v-btn
                                    @click="addChoice(item)"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    @click="removeChoice(item, choiceIndex)"
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn>
                            </v-layout>
                        </div>
                        <v-divider
                            class="pb-0 pt-3"
                            v-if="index + 1 < menuItems.length"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="menuItemsDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="createDistributionDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Create Distribution</v-card-title
                >
                <v-layout row>
                    <v-flex column xs6 class="mr-2">
                        <v-text-field
                            class="mb-0"
                            label="Week"
                            ref="createDistributionName"
                            :rules="[rules.required]"
                            v-model="newDistribution.week"
                        ></v-text-field>
                        <v-text-field
                            class="mb-0"
                            label="Distribution Description"
                            v-model="newDistribution.distributionDescription"
                        ></v-text-field>
                        <v-text-field
                            class="mb-0"
                            label="Type"
                            ref="type"
                            v-model="newDistribution.type"
                        ></v-text-field>
                        <v-layout row>
                            <v-text-field
                                class="mb-0 mr-2"
                                label="Sort"
                                type="number"
                                ref="sort"
                                v-model="newDistribution.sort"
                            ></v-text-field>
                            <v-text-field
                                class="mb-0 ml-2"
                                label="Box Count Per Family"
                                type="number"
                                ref="boxCountPerFamily"
                                v-model="newDistribution.boxCountPerFamily"
                            ></v-text-field>
                        </v-layout>
                        <v-menu
                            v-model="newDistribution.startDateDatepicker"
                            :close-on-content-click="false"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="mb-3"
                                    hide-details
                                    v-model="newDistribution.startDate"
                                    :value="newDistribution.startDate"
                                    label="Start Date"
                                    prepend-icon="mdi-calendar"
                                    ref="distributionStartDate"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="newDistribution.startDate"
                            ></v-date-picker>
                        </v-menu>
                        <v-layout row class="time-list">
                            <v-menu
                                v-model="
                                    newDistribution.changesDeadlineDatepicker
                                "
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                prepend-icon="mdi-currency-usd"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        class="mb-3 mr-3"
                                        hide-details
                                        v-model="
                                            newDistribution.changesDeadline
                                        "
                                        :value="newDistribution.changesDeadline"
                                        label="Changes Deadline"
                                        prepend-icon="mdi-calendar"
                                        ref="changesDeadline"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="newDistribution.changesDeadline"
                                ></v-date-picker>
                            </v-menu>

                            <DxDateBox
                                style="height: 45px; width: 170px;"
                                type="time"
                                class="mt-1"
                                picker-type="list"
                                :interval="15"
                                v-model="newDistribution.deadlineTime"
                            />
                        </v-layout>
                        <v-layout row class="time-list">
                            <v-menu
                                v-model="newDistribution.completedAtDatepicker"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                prepend-icon="mdi-currency-usd"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        class="mb-3 mr-3"
                                        hide-details
                                        v-model="newDistribution.completedAt"
                                        :value="newDistribution.completedAt"
                                        label="Completed At"
                                        prepend-icon="mdi-calendar"
                                        ref="completedAt"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="newDistribution.completedAt"
                                ></v-date-picker>
                            </v-menu>

                            <DxDateBox
                                style="height: 45px; width: 170px;"
                                type="time"
                                class="mt-1"
                                picker-type="list"
                                :interval="15"
                                v-model="newDistribution.completedAtTime"
                            />
                        </v-layout>

                        <v-text-field
                            class="mb-0"
                            label="Portal Message"
                            v-model="newDistribution.portalMessage"
                        ></v-text-field>
                    </v-flex>
                    <v-flex column xs6 class="ml-2">
                        <v-textarea
                            outline
                            class="mb-0"
                            label="Play Week"
                            ref="playWeek"
                            hide-details
                            v-model="newDistribution.playWeek"
                        ></v-textarea>
                        <v-btn
                            class="mb-3"
                            :disabled="!newDistribution.playWeek"
                            @click="playText(newDistribution.playWeek)"
                            color="info"
                            small
                        >
                            Play
                        </v-btn>
                        <v-textarea
                            outline
                            class="mb-0"
                            label="Menu To Play"
                            ref="menuToPlay"
                            hide-details
                            v-model="newDistribution.menuToPlay"
                        ></v-textarea>
                        <v-btn
                            class="mb-3"
                            :disabled="!newDistribution.menuToPlay"
                            @click="playText(newDistribution.menuToPlay)"
                            color="info"
                            small
                        >
                            Play
                        </v-btn>

                        <v-checkbox
                            class="mb-2 mt-0"
                            hide-details
                            label="Show On Portal"
                            color="success"
                            v-model="newDistribution.showOnPortal"
                        ></v-checkbox>
                        <v-checkbox
                            class="mb-2"
                            hide-details
                            label="Completed"
                            color="success"
                            v-model="newDistribution.isCompleted"
                        ></v-checkbox>
                        <v-checkbox
                            class="mb-2"
                            hide-details
                            label="Is Default For Type"
                            color="success"
                            v-model="newDistribution.isDefaultForType"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="createDistributionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveDistribution(newDistribution)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="updateDistributionDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Distribution</v-card-title
                >
                <v-layout row>
                    <v-flex column xs6 class="mr-2">
                        <v-text-field
                            class="mb-0"
                            label="Week"
                            ref="distributionName"
                            :rules="[rules.required]"
                            v-model="distribution.week"
                        ></v-text-field>
                        <v-text-field
                            class="mb-0"
                            label="Distribution Description"
                            v-model="distribution.distributionDescription"
                        ></v-text-field>
                        <v-text-field
                            class="mb-0"
                            label="Type"
                            ref="type"
                            v-model="distribution.type"
                        ></v-text-field>
                        <v-layout row>
                            <v-text-field
                                class="mb-0 mr-2"
                                label="Sort"
                                type="number"
                                ref="sort"
                                v-model="distribution.sort"
                            ></v-text-field>
                            <v-text-field
                                class="mb-0 ml-2"
                                label="Box Count Per Family"
                                type="number"
                                ref="boxCountPerFamily"
                                v-model="distribution.boxCountPerFamily"
                            ></v-text-field>
                        </v-layout>
                        <v-menu
                            v-model="datePickerMenu2"
                            :close-on-content-click="false"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="mb-3"
                                    hide-details
                                    v-model="distribution.startDate"
                                    :value="distribution.startDate"
                                    label="Start Date"
                                    prepend-icon="mdi-calendar"
                                    ref="distributionStartDate"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="distribution.startDate"
                            ></v-date-picker>
                        </v-menu>
                        <v-layout row class="time-list">
                            <v-menu
                                v-model="datePickerMenu4"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                prepend-icon="mdi-currency-usd"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        class="mb-3 mr-3"
                                        hide-details
                                        v-model="distribution.changesDeadline"
                                        :value="distribution.changesDeadline"
                                        label="Changes Deadline"
                                        prepend-icon="mdi-calendar"
                                        ref="changesDeadline"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="distribution.changesDeadline"
                                ></v-date-picker>
                            </v-menu>
                            <DxDateBox
                                style="height: 45px; width: 170px;"
                                type="time"
                                class="mt-1"
                                picker-type="list"
                                :interval="15"
                                v-model="distribution.deadlineTime"
                            /> </v-layout
                        ><v-layout row class="time-list">
                            <v-menu
                                v-model="datePickerMenu5"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                prepend-icon="mdi-currency-usd"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        class="mb-3 mr-3"
                                        hide-details
                                        v-model="distribution.completedAt"
                                        :value="distribution.completedAt"
                                        label="Completed At"
                                        prepend-icon="mdi-calendar"
                                        ref="completedAt"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="distribution.completedAt"
                                ></v-date-picker>
                            </v-menu>
                            <DxDateBox
                                style="height: 45px; width: 170px;"
                                type="time"
                                class="mt-1"
                                picker-type="list"
                                :interval="15"
                                v-model="distribution.completedAtTime"
                            />
                        </v-layout>

                        <v-text-field
                            class="mb-0"
                            label="Portal Message"
                            v-model="distribution.portalMessage"
                        ></v-text-field>
                    </v-flex>
                    <v-flex column xs6 class="ml-2">
                        <v-textarea
                            outline
                            class="mb-0"
                            label="Play Week"
                            ref="playWeek"
                            v-model="distribution.playWeek"
                            hide-details
                        ></v-textarea>
                        <v-btn
                            class=""
                            :disabled="!distribution.playWeek"
                            @click="playText(distribution.playWeek)"
                            color="info"
                            small
                        >
                            Play
                        </v-btn>
                        <v-textarea
                            outline
                            class="mb-0"
                            label="Menu To Play"
                            ref="menuToPlay"
                            hide-details
                            v-model="distribution.menuToPlay"
                        ></v-textarea>
                        <v-btn
                            class="mb-3"
                            :disabled="!distribution.menuToPlay"
                            @click="playText(distribution.menuToPlay)"
                            color="info"
                            small
                        >
                            Play
                        </v-btn>

                        <v-checkbox
                            class="mb-2 mt-0"
                            hide-details
                            label="Show On Portal"
                            color="success"
                            v-model="distribution.showOnPortal"
                        ></v-checkbox>
                        <v-checkbox
                            class="mb-2"
                            hide-details
                            label="Completed"
                            color="success"
                            v-model="distribution.isCompleted"
                        ></v-checkbox>
                        <v-checkbox
                            class="mb-2"
                            hide-details
                            label="Is Default For Type"
                            color="success"
                            v-model="distribution.isDefaultForType"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>

                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUpdateDistribution"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        v-if="!distribution.isClosedForChanges"
                        color="warning"
                        @click="closeDistribution(distribution)"
                    >
                        Close Distribution
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveDistribution(distribution)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";
import AWS from "aws-sdk";
import "devextreme/dist/css/dx.light.css";
import DxDateBox from "devextreme-vue/date-box";

export default {
    components: {
        DxDateBox,
    },
    data: () => ({
        title: "Distributions",
        columns: [
            {
                field: "isClosedForChanges",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                },
                icon: (value) => {
                    return value ? "mdi-check-circle" : "mdi-clock";
                },
                iconColor: (value) => {
                    return value ? "success" : "#fdb400";
                },
            },
            {
                label: "Week",
                field: "week",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Distribution Description",
                field: "distributionDescription",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Created",
                field: "dateCreated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Start Date",
                field: "startDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Completed",
                field: "isCompleted",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Closed",
                field: "isClosedForChanges",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Changes Deadline",
                field: "changesDeadline",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Completed At",
                field: "completedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Show On Portal",
                field: "showOnPortal",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Sort",
                field: "sort",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Count Per Family",
                field: "boxCountPerFamily",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Menu To Play",
                field: "menuToPlay",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Play Week",
                field: "playWeek",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Portal Message",
                field: "portalMessage",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Default For Type",
                field: "isDefaultForType",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,
        datePickerMenu: false,
        datePickerMenu2: false,
        datePickerMenu4: false,
        datePickerMenu5: false,
        createDistributionDialog: false,
        updateDistributionDialog: false,
        updateActiveDistributionDialog: false,
        menuItemsDialog: false,
        menuItems: [],
        choices: [],
        newItems: [],

        today: moment().format("YYYY-MM-DD HH:mm:ss"),

        distribution: "",
        activeDistribution: "",
        defaultDistribution: "",
        distributions: [],
        awsPolly: "",

        newDistribution: {
            distributionName: "",
            menuToPlay: "",
            playWeek: "",
            distributionDescription: "",
            week: "",
            type: "",
            changesDeadline: "",
            deadlineTime: new Date(),
            changesDeadlineDatepicker: "",
            startDate: "",
            startDateDatepicker: "",
            sort: "",
            isCompleted: false,
            showOnPortal: true,
            isDefaultForType: false,

            completedAt: "",
            completedAtTime: new Date(),
            completedAtDatepicker: "",
            portalMessage: "",

            boxCountPerFamily: "",
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    async mounted() {
        const settings = await this.getAwsSettings();

        this.awsPolly = new AWS.Polly({
            accessKeyId: settings.accessKey,
            secretAccessKey: settings.secretKey,
            region: "us-east-1",
        });
    },
    created() {
        this.user = this.$store.state.authentication.user;

        this.actions.push({
            text: "Menu Items",
            action: this.openMenuItems,
        });

        this.actions.push({
            text: "Create Distribution",
            action: this.createDistribution,
        });

        const deadlineTime = moment().toDate();

        deadlineTime.setHours(10);
        deadlineTime.setMinutes(0);
        deadlineTime.setSeconds(0);
        deadlineTime.setMilliseconds(0);

        this.newDistribution.deadlineTime = deadlineTime;

        const completedAtTime = moment().toDate();

        completedAtTime.setHours(10);
        completedAtTime.setMinutes(0);
        completedAtTime.setSeconds(0);
        completedAtTime.setMilliseconds(0);

        this.newDistribution.completedAtTime = completedAtTime;

        this.loadMenuItems();
    },
    methods: {
        async getAwsSettings() {
            const response = await this.$http.get(
                "api/adminPortal/GetAwsPollyCredentials",
            );

            return response;
        },
        onRowClicked(row) {
            this.distribution = JSON.parse(JSON.stringify(row));

            this.distribution.startDate = toISOLocal(
                new Date(this.distribution.startDate),
            ).substr(0, 10);

            this.distribution.deadlineTime = this.distribution.changesDeadline
                ? new Date(this.distribution.changesDeadline)
                : new Date();

            this.distribution.changesDeadline = this.distribution
                .changesDeadline
                ? toISOLocal(
                      new Date(this.distribution.changesDeadline),
                  ).substr(0, 10)
                : "";

            this.distribution.completedAtTime = this.distribution.completedAt
                ? new Date(this.distribution.completedAt)
                : new Date();

            this.distribution.completedAt = this.distribution.completedAt
                ? toISOLocal(new Date(this.distribution.completedAt)).substr(
                      0,
                      10,
                  )
                : "";

            this.updateDistributionDialog = true;
        },
        async loadDistributions() {
            const response = await this.$http.get(
                "odata/foodWeeklyDistributions?$filter=not (isCompleted eq true)",
            );

            this.distributions = response.value;
        },
        async loadMenuItems() {
            const response = await this.$http.get(
                "api/campDistribution/getMenuItems",
            );

            await this.loadMenuItemsChoices();

            this.menuItems = response.map((item) => {
                item.selected = false;
                item.editing = false;
                item.choices = this.choices.filter(
                    (c) => c.menuItemID == item.id,
                );
                item.choicesDisplay = item.choices.length
                    ? item.choices.map((c) => c.choice).join(",")
                    : "";

                return item;
            });
        },
        async loadMenuItemsChoices() {
            const response = await this.$http.get(
                "api/campDistribution/getMenuItemsChoices",
            );

            this.choices = response;
        },
        editItem(item) {
            item.editing = true;
        },
        rollbackItem(item) {
            item.editing = false;

            this.loadMenuItems();
        },
        addChoice(item) {
            item.choices.push({
                menuItemID: item.id,
                ivrInput: "",
                choice: "",
            });
        },
        removeChoice(item, index) {
            item.choices.splice(index, 1);
        },
        createDistribution() {
            this.createDistributionDialog = true;
        },
        openMenuItems() {
            this.$router.push({
                name: "YkCampMenuItems",
            });
        },
        cancelNewItems() {
            this.newItems = [];
        },
        async saveMenuItem(menuItem, isNew = false) {
            if (isNew) {
                if (
                    !this.$refs.newName[0].validate(true) ||
                    !this.$refs.newDistributionType[0].validate(true)
                )
                    return;
            } else {
                const itemsEditing = this.menuItems.filter((i) => i.editing);
                const index = itemsEditing.indexOf(menuItem);

                if (
                    !this.$refs.name[index].validate(true) ||
                    !this.$refs.distributionType[index].validate(true)
                )
                    return;
            }

            try {
                this.processing = true;

                const data = {
                    item: menuItem,
                    choices: menuItem.choices,
                };

                await this.$http.post(
                    "api/campDistribution/saveMenuItem",
                    data,
                );

                this.processing = false;

                if (isNew) {
                    this.newItems = [];
                }

                this.loadMenuItems();
            } catch (e) {
                this.processing = false;
            }
        },
        addItem() {
            this.newItems.push({
                name: "",
                choiceType: "",
                allowChange: "",
                standard: "",
                distributionType: "SHABBOS",
                maxInput: "",
                sort: "",
                choices: [],
            });
        },
        async deleteItems() {
            try {
                this.processing = true;

                const items = this.menuItems.filter((i) => i.selected);

                await this.$http.post(
                    "api/campDistribution/deleteItems",
                    items,
                );

                this.processing = false;

                this.loadMenuItems();
            } catch (e) {
                this.processing = false;
            }
        },
        closeUpdateDistribution() {
            this.updateDistributionDialog = false;

            this.$refs.grid.reloadGrid();
        },
        async closeDistribution(distribution) {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/campDistribution/closeDistribution",
                    distribution,
                );

                this.updateDistributionDialog = false;

                this.$refs.grid.reloadGrid();

                this.processing = false;
            } catch (e) {
                this.processing = false;

                console.log(e);
            }
        },
        async saveDistribution(distribution) {
            try {
                this.processing = true;

                if (distribution.id) {
                    if (!this.$refs.distributionName.validate(true)) return;
                } else {
                    if (!this.$refs.createDistributionName.validate(true))
                        return;
                }

                const deadlineTime = moment(distribution.deadlineTime).format(
                    "HH:mm",
                );

                const changesDeadline = moment(
                    moment(distribution.changesDeadline).format("YYYY-MM-DD") +
                        " " +
                        deadlineTime,
                ).toDate();

                const completedAtTime = moment(
                    distribution.completedAtTime,
                ).format("HH:mm");

                const completedAt = moment(
                    moment(distribution.completedAt).format("YYYY-MM-DD") +
                        " " +
                        completedAtTime,
                ).toDate();

                const data = JSON.parse(JSON.stringify(distribution));

                data.changesDeadline = moment(changesDeadline).format(
                    "YYYY-MM-DD HH:mm:ss",
                );

                data.completedAt = moment(completedAt).format(
                    "YYYY-MM-DD HH:mm:ss",
                );

                //delete data.changesDeadline;
                delete data.deadlineTime;
                delete data.completedAtTime;

                await this.$http.post(
                    "api/campDistribution/saveDistribution",
                    data,
                );

                this.createDistributionDialog = false;
                this.updateDistributionDialog = false;

                this.$refs.grid.reloadGrid();

                this.processing = false;
                //this.loadDistributions();
            } catch (e) {
                this.processing = false;

                console.log(e);
            }
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Matthew",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
    },
};
</script>
<style>
.time-list .dx-texteditor.dx-state-focused.dx-editor-outlined {
    border-color: #30a635 !important;
}
.time-list .dx-texteditor.dx-state-hover {
    border-color: #30a635 !important;
}
</style>
